<div class="h-screen overflow-hidden bg-background">
  <router-outlet></router-outlet>
</div>
